import "../assets/css/header.css";
import "../assets/css/responsive.css";
import { useTranslation } from "react-i18next";
import { useWeb3React } from "@web3-react/core";
import { connectWallet } from "../utils/connectWallet";
import Onboard from "bnc-onboard";
import { ethers } from "ethers";
import { useEffect, useState } from "react";
import imageUrl from "utils/imageUrl";
import { Link, useLocation } from "react-router-dom";

function Header(props) {
  const location = useLocation();
  const href = [
    "/rent",
    "/buy",
    "/sell",
    "/explore",
    "/profile",
    "/buy-prop-details",
    // "/admin",
  ];

  const { t, i18n } = useTranslation();
  const [lang, setLanguage] = useState("en");
  const { active, activate, account} = useWeb3React();
  console.log("is active check = ", active);
  const handlechange = (e) => {
    setLanguage(e.target.value);
    i18n.changeLanguage(e.target.value);
    console.log(e.target.value);
  };

  return (<>
    <header
      className={`header ${href.includes(location.pathname) ? "pos__rel" : ""}`}
    >
      <nav className="navbar navbar-expand-xl">
        <div className="container">
          <div className="navbar__out order-2 ">
            <div className="nav__group__btn">
          
              {active ? (
                <a
                  href="javascript:void(0)"
                  className="button button--effect  d-sm-block"
                >
                  {account.substr(0,6) + '...' + account.substr(account.length-3 ,account.length)}
                </a>
              ) : (
                <a
                  href="javascript:void(0)"
                  className="button button--effect d-sm-block"
                  onClick={() => {
                    connectWallet(activate, props.setErrorMessage);
                  }}
                >
                  {" "}
                  Connect Wallet
                  <i className="fas fa-wallet mx-1"></i>
                </a>
              )}
            </div>
            {/* <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#primaryNav"
              aria-controls="primaryNav"
              aria-expanded="false"
              aria-label="Toggle Primary Nav"
            >
              <span className="icon-bar top-bar"></span>
              <span className="icon-bar middle-bar"></span>
              <span className="icon-bar bottom-bar"></span>
            </button> */}
          </div>
          <Link to="/" className="navbar-brand" >
            <img src={imageUrl("logo.png")} alt="Logo" className="logo" />
            {/* Your Logo */}
          </Link>
        </div>
      </nav>
    </header>
    <div class="cs-height_80 cs-height_lg_80"></div>
    </>
    // <!-- ==== #header end ==== -->
  );
}

export default Header;
